export function fileupload(bar,percent,showimg,progress,files,btn,action){
    //var dir_name='';     
    $("#myupload").ajaxSubmit({ 
            //dataType:  'json', //数据格式为json 
            url:action,
            //async:false,
            //type:"POST",
            //data:"dir_name="+dir_name,
            beforeSend: function() { //开始上传 
                showimg.empty(); //清空显示的图片 
                progress.show(); //显示进度条 
                var percentVal = '0%'; //开始进度为0% 
                bar.width(percentVal); //进度条的宽度 
                percent.html(percentVal); //显示进度为0% 
                btn.html("Loading..."); //上传按钮显示上传中 
            }, 
            uploadProgress: function(event, position, total, percentComplete) { 
                var percentVal = percentComplete + '%'; //获得进度 
                bar.width(percentVal); //上传进度条宽度变宽 
                percent.html(percentVal); //显示上传进度百分比 
            }, 
            success: function(data) { //成功             	
                var re=$.parseJSON(data);
                //获得后台返回的json数据，显示文件名，大小，以及删除按钮 
                files.html("<div style='padding-top:8%' id='input_name'><b class='txet-success'><i class='glyphicon glyphicon-ok-circle'>"+re.name+"("+re.size+"k)</i></b></div>");                  
                //显示上传后的图片    
                //console.log(data)             
                btn.html("Select Files"); 
                ///return true;//上传按钮还原 
            }, 
            error:function(xhr){ //上传失败                
                btn.html("Upload Failed"); 
                bar.width('0'); 
                files.html(xhr.responseText); 
                //return false;//返回失败信息 
            } 
    }); 
}